import { useTheme } from "@mui/material/styles";
export var RadioButtonGroupStyles = function () {
    var theme = useTheme();
    return {
        content: {
            formLabel: {
                mb: 1,
            },
            radioGroup: {
                rowGap: "12px",
                ".MuiRadioGroup-root": {
                    rowGap: "12px",
                },
            },
            formControlLabel: function (selected) { return ({
                border: "1px solid ".concat(selected ? theme.palette.success.main : theme.palette.grey[200]),
                borderRadius: "12px",
                p: 2,
                pl: 1,
                m: 0,
                ".MuiFormControlLabel-label": {
                    width: "100%",
                },
            }); },
        },
    };
};
